import type { IFolder } from "@/types/folder";

export function findFolderById(
  folders: IFolder[],
  folderId: number
): IFolder | undefined {
  for (const folder of folders) {
    if (folder.id === folderId) {
      return { ...folder };
    }

    const subfolder = folder.subfolders?.find(
      (subfolder) => subfolder.id === folderId
    );
    if (subfolder) {
      return { ...subfolder };
    }
  }
}
